import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import eco_grant from '../2026 Rotary Club Grant Application.docx';

const margin = '5px';
// const rotary_blue = '#005daa';
const useStyles = makeStyles({
    button1: {
        margin: margin,
        // backgroundColor: '#005daa',
        // '&:hover': { backgroundColor: '#0044aa' }
    },
    button2: {
        margin: margin,
        backgroundColor: 'red',
        '&:hover': { backgroundColor: '#aa0000' }
    }
});

export default function Scholarship() {
    const classes = useStyles();
    return (
        <React.Fragment>
            <h1 style={{ fontWeight: 'bold' }}>Economic Grant</h1>
            {/* <span style={{ fontWeight: 'bold' }}>NEW Deadline: July 31, 2020</span><br /> */}
            <Button className={classes.button1} color='primary' variant='contained' onClick={() => {
                window.open(eco_grant, '_blank')
            }}>Economic Development Grant</Button>
        </React.Fragment>
    );
}
